module.exports = __webpack_public_path__ + "fonts/AvenirLTStd-Heavy.1dab7f81.woff";